function getBaseApiUrl(origin = globalThis.location.origin) {
  if (origin.includes("find-support-services-admin.hackney")) {
    return "https://b56cfvfyb8.execute-api.eu-west-2.amazonaws.com/production/api/v1";
  }

  if (origin.includes("find-support-services-staging-admin.hackney")) {
    return "https://fjilyjs06h.execute-api.eu-west-2.amazonaws.com/staging/api/v1";
  }

  if (origin.includes("find-support-services-development-admin.hackney")) {
    return "https://dyh12dh1sg.execute-api.eu-west-2.amazonaws.com/development/api/v1";
  }

  return "/api";
}

const BASE_API_URL = getBaseApiUrl();

export default BASE_API_URL;
export { getBaseApiUrl };
